import { ClientFactory } from '@lmt/unicorn-shared/app/api/client-factory';
import {
  DeviceModel,
  CreateMeasurementMappingDto,
  UpdateMeasurementMappingDto,
  MeasurementMappingDto,
} from '@lmt/shared-types';

export interface Option {
  value: number;
  displayValue: string;
}

export const deviceModels: Option[] = [
  {
    value: DeviceModel.MiniScreen,
    displayValue: 'MiniScreen',
  },
];

export async function createMapping(dto: CreateMeasurementMappingDto) {
  return await ClientFactory.MeasurementMappingClient.create(dto);
}

export async function editMapping(
  id: number,
  dto: UpdateMeasurementMappingDto,
) {
  return await ClientFactory.MeasurementMappingClient.edit(id, dto);
}

export async function removeMapping(id: number) {
  await ClientFactory.MeasurementMappingClient.remove(id);
}
